import { render, staticRenderFns } from "./purchase_order_detail.vue?vue&type=template&id=c6639ce0&scoped=true&"
import script from "./purchase_order_detail.vue?vue&type=script&lang=ts&"
export * from "./purchase_order_detail.vue?vue&type=script&lang=ts&"
import style0 from "./purchase_order_detail.vue?vue&type=style&index=0&id=c6639ce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6639ce0",
  null
  
)

export default component.exports